// Keep this file dependency-free to avoid circular imports between routing and components.
export const ACCOUNT_SETTINGS_PAGES = [
  'AccountSettingsPage',
  'ProfileSettingsPage',
  'PasswordChangePage',
  'StripePayoutPage',
  'PaymentMethodsPage',
];


